"use client";
import React, { useContext, useState } from "react";

interface AudioListContextType {
  playingItemId: null | string;
  setPlayingItemId: React.Dispatch<React.SetStateAction<null | string>>;
}

const AudioListContext = React.createContext<AudioListContextType | null>(null);

export function AudioListProvider({ children }: { children: React.ReactNode }) {
  const [playingItemId, setPlayingItemId] = useState<null | string>(null);

  return <AudioListContext.Provider value={{ playingItemId, setPlayingItemId }}>{children}</AudioListContext.Provider>;
}

export const useAudioList = () => {
  const context = useContext(AudioListContext);
  if (!context) throw new Error("useAudioList must be used within a AudioListProvider");
  return context;
};
